import { CustomFieldSchema, Fields } from 'common/form';
import { UpsertTalentPoolFormData } from 'modules/candidate-profile/forms/schema';

export const getUpsertTalentPoolFields = (
  teamField: CustomFieldSchema
): Fields<UpsertTalentPoolFormData> => ({
  name: {
    type: 'text',
    label: 'Name this talent list'
  },
  teamIds: teamField,
  description: {
    type: 'textarea',
    label: 'Add description (optional)',
    rows: 4
  }
});
